import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import MinorAilments from "./minor-ailment/MinorAilments";
import MedicationReview from "./medication-review/MedicationReview";
import {
  fetchClinicalService,
  fetchMedicationReview,
  setClinicalServiceName,
} from "../../../../redux/modules/clinical-services/actions";
import { ClinicalServiceTypes } from "../../text/data";
import { useLocation } from "react-router-dom";
import { fetchNotepadByService } from "../../../../redux/modules/patient/actions";
import MinorAilemntForms from "./minor-ailment/documentationForm";
import MedicationReviewForms from "./medication-review/documentationForm";

const LoadServiceForms = ({}) => {
  const { id: patientId, serviceId, formType } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    clinicalServiceObj,
    clinicalServicesSmall,
    clinicalServiceName,
    medications,
  } = useSelector((state) => state.clinicalService);
  const { patient } = useSelector((state) => state.patients); 
  const [serviceTypeCode, setServiceTypeCode] = useState(null);

  useEffect(() => {
    const serviceTypeCode = findCodeById(serviceId);
    setServiceTypeCode(serviceTypeCode);
    dispatch(setClinicalServiceName(serviceTypeCode));
    if (serviceTypeCode === ClinicalServiceTypes.AllergicRhinitis)
      dispatch(fetchClinicalService(serviceId));
    else if (serviceTypeCode === ClinicalServiceTypes.MedicationReview)
      dispatch(fetchMedicationReview(serviceId));

    // Fetch notes specific to this service only
    if (serviceTypeCode && serviceId) {
      dispatch(fetchNotepadByService(serviceTypeCode, serviceId));
    }
  }, [patientId, serviceId, clinicalServiceName, clinicalServicesSmall]);

  if (clinicalServiceObj === null) return null;

  function findCodeById(id) {
    if (clinicalServicesSmall !== null || clinicalServicesSmall !== undefined) {
      // Search in minorAilments array
      if (clinicalServicesSmall.minorAilments)
        for (const minorAilment of clinicalServicesSmall.minorAilments) {
          if (minorAilment.id === id) {
            return minorAilment.minorAilmentTypeCode;
          }
        }
      // Search in medicationReviews array
      if (clinicalServicesSmall.medicationReviews)
        for (const medicationReview of clinicalServicesSmall.medicationReviews) {
          if (medicationReview.id === id) {
            return medicationReview.medicationReviewTypeCode;
          }
        }
    }
    return null; // Return null if the id is not found in either array
  }

  const renderStep = () => {
    switch (serviceTypeCode) {
      case ClinicalServiceTypes.AllergicRhinitis:
         return (
          <MinorAilemntForms
            clinicalServiceObj={clinicalServiceObj}
            clinicalServiceName={clinicalServiceName}
            patient={patient}
            formType={formType}
            onBack={(e) =>
              navigate(`/patient/${patientId}/clinical-services/${serviceId}`)
            }
          />
        );
      case ClinicalServiceTypes.MedicationReview:
        return (
          <MedicationReviewForms
            clinicalServiceObj={clinicalServiceObj}
            clinicalServiceName={clinicalServiceName}
            medications={medications}
            patient={patient}
            formType={formType}
            onBack={(e) =>
              navigate(`/patient/${patientId}/clinical-services/${serviceId}`)
            }
          />
        );
      default:
        break;
    }
  };

  return <div className="">{renderStep()}</div>;
};

export default LoadServiceForms;
